export enum DivisionStatus {
  Active = 0,
  Pending = 1,
  Archived = 2,
  OnBoarding = 3
}

export const DivisionStatusMapping: Record<DivisionStatus, string> = {
  [DivisionStatus.Active]: 'Active',
  [DivisionStatus.Pending]: 'Pending',
  [DivisionStatus.Archived]: 'Archived',
  [DivisionStatus.OnBoarding]: 'On Boarding'
};
